const faqs = [
  {
    q: '每日大赛mrds是一个什么样的平台？',
    a: '每日大赛mrds是国内领先的每日吃瓜排位赛平台，聚焦全网最新黑料评选与实时爆料排行。我们以社区投票为核心，让每一位吃瓜群众都能参与评选，决定今日瓜王归属，同时提供热点话题追踪和娱乐梗图精选。',
  },
  {
    q: '榜单排名是如何产生的？',
    a: '所有榜单排名均由社区真实投票产生，全程公开透明。每一位注册用户都可以对心仪的黑料和爆料进行投票，系统根据票数实时更新排行，拒绝人工干预和刷票行为，确保每一条排行的公信力。',
  },
  {
    q: '如何参与每日吃瓜大赛？',
    a: '非常简单！浏览每日更新的爆料内容，为你认为最劲爆、最有趣的吃瓜事件投出宝贵一票。你也可以在专题区发表你的观点，或者通过投稿入口提供新的爆料线索，优质内容会直接进入评选池。',
  },
  {
    q: '平台上的爆料信息是否真实可靠？',
    a: '我们建立了严格的审核机制，所有上架的爆料内容都经过编辑团队的多方核实。标注"独家爆料"的内容来源更为严格，确保信息可靠性。同时我们鼓励用户在评论区理性讨论，共同维护健康的吃瓜环境。',
  },
  {
    q: '我可以向平台投稿爆料吗？',
    a: '当然可以！我们欢迎所有圈内人士和热心吃瓜群众投稿。请通过页面上的"联系我们"入口发送你的爆料内容，优质独家爆料一经采用，将获得首页推荐位展示，并有机会参与月度优秀爆料评选。',
  },
  {
    q: '平台的内容更新频率是怎样的？',
    a: '每日大赛mrds坚持7×24小时全天候内容更新。我们的编辑团队实时追踪全网热点，确保榜单和爆料信息始终是最新鲜的内容。排行榜每小时自动刷新一次，让吃瓜永远不过时。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-primary-500 tracking-wider uppercase mb-3 whitespace-nowrap">
            FAQ
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            吃瓜问答
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl border border-background-200/70 p-5 md:p-6 transition-all duration-300 hover:border-primary-200/80"
            >
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-3">
                <span className="text-primary-500 mr-2">Q{i + 1}.</span>
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}